'use strict';

require('./UserService.js');
require('../company/users/CompanyUserPermissionService.js');

function CurrentUserService(
  $q,
  UserService,
  $window,
  CompanyUserPermissionService
) {
  var currentUser;
  return {
    get: function() {
      var deferred = $q.defer();
      if (!currentUser || currentUser.id !== $window.localStorage.userId) {
        UserService.get({userId: $window.localStorage.userId}, function(user) {
          deferred.resolve(user);
          currentUser = user;
        });
      } else {
        deferred.resolve(currentUser);
      }

      return deferred.promise;
    },
    destroy: function() {
      currentUser = null;
    },
    getPermissions: function(companyId) {
      return this.get().then(function(user) {
        return CompanyUserPermissionService.query({companyId: companyId, userId: user.id}).$promise;
      });
    }
  };
}

angular.module('dokiv')
  .factory('CurrentUserService', [
    '$q',
    'UserService',
    '$window',
    'CompanyUserPermissionService',
    CurrentUserService
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/user/CurrentUserService.js
// module id = 18
// module chunks = 0